import { get } from '../index';

export const getDefaultShoppingList = (familyId) => {
  return get(`family/${familyId}/shopping-list/default`);
};